<script setup>
import RatingSquareScore from '@/Pages/DomainScore/Partials/RatingSquareScore.vue';
import RiskLabel from '@/Pages/DomainScore/Partials/RiskLabel.vue';
import DmarcCard from '@/Pages/DomainScore/Partials/DetailedReport/Impersonation/DmarcCard.vue';
import SpfCard from '@/Pages/DomainScore/Partials/DetailedReport/Impersonation/SpfCard.vue';
import DkimCard from '@/Pages/DomainScore/Partials/DetailedReport/Impersonation/DkimCard.vue';
import { inject } from 'vue';
import ACTION_TYPES, {
  getActionTypeFromScore
} from '@/Common/Enum/ActionType.js';
import Help from '@/Components/Help.vue';

const result = inject('score');
const actionType = getActionTypeFromScore(result.impersonation.score);
</script>

<template>
  <div>
    <div class="flex items-start gap-3">
      <div class="flex flex-col items-center">
        <RatingSquareScore :score="result.impersonation.score" />
        <RiskLabel
          :score="result.impersonation.score"
          class="mt-1 text-sm text-nowrap"
        />
      </div>
      <div class="flex flex-col gap-2">
        <h5 class="flex items-center gap-2 text-lg font-bold text-white">
          {{
            $t(
              'domain_score.partials.detailed_report.impersonation.impersonation_detail_card.impersonation_rating'
            )
          }}
          <Help
            :text="
              $t(
                'domain_score.partials.detailed_report.impersonation.impersonation_detail_card.impersonation_rating_help'
              )
            "
          />
        </h5>
        <p v-if="actionType === ACTION_TYPES.NO_ACTION">
          {{
            $t(
              'domain_score.partials.detailed_report.impersonation.impersonation_detail_card.no_action_required'
            )
          }}
        </p>
        <p v-else-if="actionType === ACTION_TYPES.ACTION_RECOMMENDED">
          {{
            $t(
              'domain_score.partials.detailed_report.impersonation.impersonation_detail_card.action_recommended'
            )
          }}
        </p>
        <p v-else>
          {{
            $t(
              'domain_score.partials.detailed_report.impersonation.impersonation_detail_card.action_required'
            )
          }}
        </p>
      </div>
    </div>
    <div class="mt-4 flex flex-col gap-2 md:gap-4">
      <DmarcCard />
      <SpfCard />
      <DkimCard />
    </div>
  </div>
</template>
